import { ResourceDescriptor } from "./common";

const client_role_mapping_rule: ResourceDescriptor = {
    url: "client_role_mapping_rules",
    identifiers: ["pattern", "role"],
    orders: {},
    renderers: {
        delete: {
            role: (val, _) => {
                return val.name;
            },
        },
    },
};

export default client_role_mapping_rule;
